import React from "react";
import "../../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../../assets/tether/tether.min.css";
import "../../../assets/bootstrap/css/bootstrap.min.css";
import "../../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../../assets/dropdown/css/style.css";
import "../../../assets/socicon/css/styles.css";
import "../../../assets/theme/css/style.css";
import "../../../assets/mobirise/css/mbr-additional.css";

const Footer = () => {
  return (
    <section className="footer3 cid-smIvGalAcO" once="footers" id="footer3-1u">
      <div className="container">
        <div className="media-container-row align-center mbr-white">
          <div className="row row-links">
            <ul className="foot-menu">
              <li className="foot-menu-item mbr-fonts-style display-7">
                <a href="/landing_page" className="text-primary">
                  Home
                </a>
              </li>
              <li className="foot-menu-item mbr-fonts-style display-7">
                <a href="/contacts" className="text-primary">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div className="row social-row">
            <div className="social-list align-right pb-2">
              <div className="soc-item">
                <a
                  href="https://www.facebook.com/masstaxiads"
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                </a>
              </div>
              <div className="soc-item">
                <a
                  href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                </a>
              </div>
            </div>
          </div>
          <div className="row row-copirayt">
            <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
              © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC. All
              Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
